import React, { useState, useEffect } from 'react';

import { Input } from '@nearst/ui';
import { formatPrice } from '@utils/currency';
import { getPrice, getMarkupPercentage } from '@nearst/delivery-channels';

const PriceMarkupInput = ({ stockItem, currency, onChange, channel, ...props }) => {
	const [value, setValue] = useState('');
	useEffect(() => {
		const defaultValue = getMarkupPercentage(stockItem, channel.config, channel.id);
		setValue(defaultValue);
	}, [stockItem, setValue, channel]);

	const mutatedStockItem = { ...stockItem, deliveryMarkup: { [channel.id]: value } };
	const newPrice = getPrice(mutatedStockItem, channel.config, channel.id, false);

	return (
		<>
			<Input
				suffix="%"
				type="number"
				min="0"
				max="100"
				{...props}
				value={value}
				onChange={({ target }) => setValue(target.value)}
				onBlur={() => {
					if (value === '') return onChange(undefined);
					if (value < 0) {
						setValue('0');
						return onChange(0);
					} else {
						onChange(Number(value) || 0);
					}
				}}
			/>
			<p>Price shown: {formatPrice(newPrice, currency)}</p>
		</>
	);
};

export default PriceMarkupInput;
